import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NoteInputDirective } from './note-input.directive';

@NgModule({
  declarations: [NoteInputDirective],
  imports: [CommonModule],
  exports: [NoteInputDirective],
})
export class NoteInputDirectiveModule {}
